import React from 'react';

const AJAX_Database = () => {
  return (
    <div >
      <h1>AJAX_Database</h1>
      <p>Placeholder component for: "AJAX Database"</p>
    </div>
  );
};

export default AJAX_Database;
